import React from 'react';
import {Typography} from 'components/Typography';

type TUnitPriceBadgeProps = {
    unitPrice: string;
    className?: string;
};

export const UnitPriceBadge = (props: TUnitPriceBadgeProps) => {
    const {unitPrice, className} = props;

    return (
        <div className={className}>
            <Typography variant={'label-12-r'}>Цена за штуку {unitPrice}</Typography>
        </div>
    );
};
